import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import { Flex } from '../UI/Flex/Flex';
import { SideChatMessage } from '@assets/model/SideChatStore';

export const ModalShowMessageThinking = observer(
    (props: { m: SideChatMessage }) => {
        const { m } = props;

        const messages = m.thinking.map(e => {
            return (
                <Flex style={{ width: '100%' }}>
                    <div style={{ width: '100px', border: '1px solid black' }}>
                        {e.type}
                    </div>
                    <div
                        style={{
                            border: '1px solid black',
                            width: 'auto',
                            flex: 1
                        }}
                    >
                        {e.content}
                    </div>
                </Flex>
            );
        });
        return (
            <Flex fillCell={true} direction="column">
                <ScrollPanel>
                    <Flex direction="column">{messages}</Flex>
                </ScrollPanel>
            </Flex>
        );
    }
);
